/**
 * Creates an empty vacancy for the currently toggled organisation and opens it in the edit form.
 *
 * Companies use this directly from the vacancy type selection modal: they have no vacancy templates,
 * so the "start from blank or from a template" step is skipped for them entirely.
 */
export async function createVacancyFromBlank (nuxtApp) {
  const vacancyId = await nuxtApp.$postToBackend('/createVacancy', { organisationId: nuxtApp.$globalState.toggledOrganisationId })
  await nuxtApp.$router.push(nuxtApp.$findPath('/vrijwilligerswerk/:vacancyName/:id', { vacancyName: 'new-vacancy', id: vacancyId, platformUrl: nuxtApp.$getPlatformOfUser()?.url }, null, { new: true }))
}
